export interface FeatureFlags {
  enableRegistration: boolean;
  enableEmailNotifications: boolean;
  skipVerification: boolean;
  // Add more feature flags as needed
}

/**
 * Helper function to convert environment variable to boolean
 * Handles various truthy values like 'true', '1', 'yes'
 */
const envToBool = (value: any, defaultValue: boolean): boolean => {
  if (value === undefined || value === null) {
    return defaultValue;
  }
  
  // Convert to string and check various truthy values
  const strValue = String(value).toLowerCase();
  return strValue === 'true' || strValue === '1' || strValue === 'yes';
};

// Read from environment variables with fallbacks to default values
const featureFlags: FeatureFlags = {
  enableRegistration: envToBool(import.meta.env.VITE_ENABLE_REGISTRATION, false),
  enableEmailNotifications: envToBool(import.meta.env.VITE_ENABLE_EMAIL_NOTIFICATIONS, false),
  skipVerification: envToBool(import.meta.env.VITE_SKIP_VERIFICATION, true),
};

// Export the configuration
export { featureFlags };

// Log feature flags in development mode
if (import.meta.env.DEV) {
  console.log('Environment Variables:', {
    VITE_ENABLE_REGISTRATION: import.meta.env.VITE_ENABLE_REGISTRATION,
    VITE_ENABLE_EMAIL_NOTIFICATIONS: import.meta.env.VITE_ENABLE_EMAIL_NOTIFICATIONS,
    VITE_SKIP_VERIFICATION: import.meta.env.VITE_SKIP_VERIFICATION,
  });
  console.log('Feature Flags:', featureFlags);
}
